






























import PageLayout from '@/components/page/PageLayout.vue'
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import Settle from './Settle.vue'
import Verify from './Verify.vue'
import Analysis from './Analysis.vue'
import MedicalRecord from './MedicalRecord.vue'
import PersonalInjury from './PersonalInjury.vue'
import KeyVisits from './KeyVisits.vue'
import VisitTrajectory from './VisitTrajectory.vue'
import Tips from '@/components/Tips.vue'
const authMap = {
	verify: {
		title: '票据验证',
		authStr: 'bill2Add:verify',
		code: '2',
	},
	parse: {
		title: '票据解析',
		authStr: 'bill2Add:parse',
		code: '3',
	},
	settle: {
		title: '票据查询',
		authStr: 'bill2Add:settle',
		code: '1',
	},
	medicalRecord: {
		title: '就诊记录',
		authStr: 'bill2Add:medicalRecord',
		code: '4',
	},
	grsbpc: {
		title: '个人伤病排查',
		authStr: 'bill2Add:grsbpc',
		code: '5',
	},
	zdjzpc: {
		title: '重点就诊排查',
		authStr: 'bill2Add:zdjzpc',
		code: '6',
	},
	jzgjpc: {
		title: '就诊轨迹排查',
		authStr: 'bill2Add:jzgjpc',
		code: '7',
	},
}
const authList = [
	authMap.verify,
	authMap.parse,
	authMap.settle,
	authMap.medicalRecord,
	authMap.grsbpc,
	authMap.zdjzpc,
	authMap.jzgjpc,
]
const tipsMap = {
	'1':
		'提示：该接口可以通过就诊人姓名及身份证查询到对应医院所产生的医疗电子发票！',
	'2':
		'提示：该接口可以通过录入的电子发票纸质信息查询到该票据对应的电子票据信息！',
	'4': '提示：该接口可以查询就诊人所有的就诊记录！',
	'5': '提示：已就诊中风险等级较高的诊断，最多10个，可辅助判断是否提起调查。',
	'6':
		'提示：特定险种可能相关的就诊记录和疑似诊断，可辅助判断是否实地调取病案。',
	'7': '提示：2年内就诊记录的相关字段，可辅助定位较高风险就诊医院。',
}

@Component({
	name: 'addBill2Task',
	components: {
		Settle,
		PageLayout,
		Tips,
		Verify,
		Analysis,
		MedicalRecord,
		PersonalInjury,
		KeyVisits,
		VisitTrajectory,
	},
})
export default class addTaskPage extends Vue {
	private active: any = '1'
	private tipsMap = tipsMap

	private get tabList() {
		if (this.$route.query.addSettle) {
			// 详情中查询发票
			return [authMap.settle].filter((item: any) => this.$auth(item.authStr))
		} else {
			return authList.filter((item: any) => this.$auth(item.authStr))
		}
	}

	private toggle(i: any) {
		this.active = i
	}

	private created() {
		// 放在created中保证切换keep-alive页签切换时录入信息不丢失
		this.active = this.tabList[0] && this.tabList[0].code
	}
}
